<template>
    <v-container grid-list-md v-if="sample">
        <v-card-title>
            <v-flex xs12 md12 lg12 class="text-xs-right">
                <TrackNumber :sample_order_id="sample.id" :track_number="sample.track_number" v-on:created="$emit('updated')"></TrackNumber>

                <v-dialog v-model="dialog" persistent max-width="600px">
                    <v-btn slot="activator" color="red" dark>Edit status</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Edit status</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 d-flex>
                                        <v-select
                                                v-model="status"
                                                :items="statuses"
                                                label="Standard"
                                                item-text="name"
                                                item-value="value"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                            <v-btn color="blue darken-1" flat @click="dialog = false; updateStatus()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-btn color="green" dark @click="finishUpload()" v-if="sample.status_id == '2'">I finished uploading documents</v-btn>
            </v-flex>
            <v-flex xs6 md6 lg6>
                <CreateComponent :id="sample.id" v-on:created="getProducts()"></CreateComponent>
            </v-flex>
            <v-flex xs6 md6 lg6>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 lg12 mt-3>
                <p class="title">Shipping address: {{ sample.shipping_address }}, {{ sample.shipping_address_obj ? sample.shipping_address_obj.country_name : '' }}</p>
                <p class="title">Tracking number: {{ sample.track_number }}</p>
            </v-flex>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="products.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs">{{ props.item.lc_code }}</td>
                <td class="text-xs">{{ props.item.ftn_code }}</td>
                <td class="text-xs">{{ props.item.name }}</td>
                <td class="text-xs">{{ props.item.quantity }}</td>
                <td class="text-xs">
                    <!--<v-btn flat icon v-if="props.item.sent && sample.status_id == '2'" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box</v-icon></v-btn>
                    <v-btn flat icon v-if="!props.item.sent && sample.status_id == '2'" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box_outline_blank</v-icon></v-btn>
                    <v-btn flat icon disabled v-if="props.item.sent && sample.status_id != '2'" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box</v-icon></v-btn>
                    <v-btn flat icon disabled v-if="!props.item.sent && sample.status_id != '2'" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box_outline_blank</v-icon></v-btn>
                -->
                    <v-btn flat icon v-if="props.item.sent" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box</v-icon></v-btn>
                    <v-btn flat icon v-if="!props.item.sent" @click.prevent="sentProduct(props.item.id)"><v-icon>check_box_outline_blank</v-icon></v-btn>
                </td>
                <td class="text-xs">
                    <FeedBackComponent :sample_order_id="sample.id" :sample_order_line="props.item"></FeedBackComponent>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="products.meta">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ products.meta.from }} to {{ products.meta.to }} of {{ products.meta.total }} entries</p>
        </div>
        <br>
        <DocumentComponent :order_id="sample.id" :sample="sample"></DocumentComponent>
        <br>
        <CommentComponent :sample="sample"></CommentComponent>
    </v-container>
</template>

<script>
    import CommentComponent from '../components/CommentComponent';
    import DocumentComponent from '../components/DocumentComponent';
    import CreateComponent from '../../../admin/samples/views/components/CreateProductComponent';
    import EditProductComponent from '../components/EditProductComponent';
    import TrackNumber from '../components/TrackNumberComponent';
    import FeedBackComponent from '../components/FeedbackComponent';

    export default {
        props: ['sample'],
        data: function () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Reference',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    { text: 'SUPPLIER Code', value: 'product', sortable: false },
                    { text: 'Sample', value: 'units', sortable: false },
                    { text: 'Quantity', value: 'pricekg', sortable: false },
                    { text: 'Sent', value: 'price', sortable: false },
                    { text: 'Feedback', value: 'feedback', sortable: false }
                ],
                products: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                statuses: [
                    { name: 'In preparation', value: '2' },
                    { name: 'Document uploaded', value: '3' },
                    { name: 'Canceled', value: '6' },
                ],
                status: null,
                dialog: null
            }
        },
        created () {
            this.status = String(this.sample.status_id);
            if (this.sample) {
                this.getProducts();
            }
            this.debouncedGetProducts = _.debounce(this.getProducts, 500)
        },
        watch: {
            sample: function () {
                this.getProducts();
                this.status = String(this.sample.status_id);
            },
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteClient', {
                            id: id
                        }).then((res) => {

                            this.getProducts();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getProducts();
            },
            getProducts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.sample.id
                    },
                    id: this.sample.id
                };
                this.$store.dispatch('getSampleOrderLines', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            sentProduct (id) {
                this.$store.dispatch('sentSampleOrderLine', {
                    sample_order_id: this.sample.id,
                    sample_order_line_id: id
                }).then((res) => {
                    this.getProducts();
                }).catch((error) => {

                });
            },
            finishUpload() {
                this.$store.dispatch('finishUpload', {
                    sample_order_id: this.sample.id
                }).then((res) => {
                    this.$emit('updated');
                }).catch((error) => {

                });
            },
            updateStatus () {
                this.$store.dispatch('updateStatusSampleOrders', {
                    id: this.sample.id,
                    status: this.status
                }).then((res) => {
                    this.$emit('updated');
                }).catch((error) => {

                });
            }
        },
        components: {
            CommentComponent,
            CreateComponent,
            EditProductComponent,
            TrackNumber,
            DocumentComponent,
            FeedBackComponent
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fnt/samples/views/OrderComponent.vue